/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { HubbleShipmentFiltersQuery } from "./HubbleShipmentFiltersQuery";
import {
  HubbleShipmentFiltersQueryFromJSON,
  HubbleShipmentFiltersQueryFromJSONTyped,
  HubbleShipmentFiltersQueryToJSON,
  HubbleShipmentFiltersQueryToJSONTyped,
} from "./HubbleShipmentFiltersQuery";

/**
 *
 * @export
 * @interface ExperimentMetadata
 */
export interface ExperimentMetadata {
  /**
   *
   * @type {number}
   * @memberof ExperimentMetadata
   */
  version: number;
  /**
   *
   * @type {HubbleShipmentFiltersQuery}
   * @memberof ExperimentMetadata
   */
  filters?: HubbleShipmentFiltersQuery | null;
}

/**
 * Check if a given object implements the ExperimentMetadata interface.
 */
export function instanceOfExperimentMetadata(
  value: object,
): value is ExperimentMetadata {
  if (!("version" in value) || value["version"] === undefined) return false;
  return true;
}

export function ExperimentMetadataFromJSON(json: any): ExperimentMetadata {
  return ExperimentMetadataFromJSONTyped(json, false);
}

export function ExperimentMetadataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ExperimentMetadata {
  if (json == null) {
    return json;
  }
  return {
    version: json["version"],
    filters:
      json["filters"] == null
        ? undefined
        : HubbleShipmentFiltersQueryFromJSON(json["filters"]),
  };
}

export function ExperimentMetadataToJSON(json: any): ExperimentMetadata {
  return ExperimentMetadataToJSONTyped(json, false);
}

export function ExperimentMetadataToJSONTyped(
  value?: ExperimentMetadata | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    version: value["version"],
    filters: HubbleShipmentFiltersQueryToJSON(value["filters"]),
  };
}
